import axios from "axios";
var result = { Status: true, Message: "", Data: null };
export const saveOperatorInfo = async (values , operatorKey) => {
    var result = { Status: true, Message: "", Data: null };   
    var Maindata = {
        key : operatorKey,
        data: {
            OperatorId: values.operatorId,
            OperatorName: values.operatorName,
            UssdCode: values.ussdCode,
            Note: values.note,
            IsActive: values.isActive,
        }
    }

    if (values.operatorId === '' || values.operatorId === null) {
        try {
            const response = await axios.post(`/api/Operator/Create`, Maindata);
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    } else {
        Maindata.data.OperatorId = values.operatorId;
        try {
            const response = await axios.put(`/api/Operator/${Maindata.data.OperatorId}`, Maindata.data)
            if (response && response.status === 200) {
                return response.data;
            } else {
                result.Status = false;
                result.Message = "Something went wrong";
                return result;
            }
        } catch (error) {
            if (error.response.status === 401) {
                return error.response.status;
            } else {
                result.Status = false;
                result.Message = "Unhandled exception";
                return result;
            }
        }
    }
}

export const GetOperatorList = async (auth) => {
    let response;
    try {
       
            response = await axios.post(`/api/Operator/GetOperatorList`);
        
        if (response && response.status === 200) {
            return response.data.records;
        } else {
            console.error("GetUser Error:")
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}

export const GetOperatorById = async (id) => {
    try {
        const response = await axios.post(`/api/Operator/GetOperatorById`, { id: id });
        if (response.status === 200) {
            return response.data;
        } else {
            return response.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        } else {
            let exceptionData = { expmessage: error.response.data.title, expstring: true }
            return exceptionData;
        }
    }
}
export const deleteOperator = async (values) => {
    try {
        var data = {
            OperatorId: values.operatorId,
        }
        const response = await axios.post(`/api/Operator/Delete`, data);
        if (response && response.status === 200) {
            return response.data;
        } else {
            result.Status = false;
            result.Message = "Something went wrong";
            return result;
        }
    } catch (error) {
        console.log(error)
    }
}

